import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Mail, Phone, MapPin, Twitter, Facebook, Instagram, Youtube, ArrowRight } from 'lucide-react';
import Logo from '../assets/ssk_logo_long.png'

const Footer = () => {
  const footerLinks = {
    product: [
      { name: 'Features', href: '#features' },
      { name: 'Pricing', href: '#pricing' },
      { name: 'Demo', href: '#demo' },
      { name: 'Log in', href: 'https://portal.sportstreamkit.com/login' },
      // { name: 'Integrations', href: '#' }
    ],
    company: [
      // { name: 'About Us', href: '#' },
      // { name: 'Careers', href: '#' },
      // { name: 'Press', href: '#' },
      // { name: 'Partners', href: '#' },
      { name: 'Contact', href: 'mailto:info@sportstreamkit.com' }
    ],
    // support: [
    //   { name: 'Help Center', href: '#' },
    //   { name: 'Documentation', href: '#' },
    //   { name: 'API Reference', href: '#' },
    //   { name: 'Community', href: '#' },
    //   { name: 'Status', href: '#' }
    // ],
    legal: [
      // { name: 'Privacy Policy', href: '#' },
      { name: 'Terms of Service', href: 'https://portal.sportstreamkit.com/terms-and-conditions' },
      // { name: 'Cookie Policy', href: '#' },
      // { name: 'GDPR', href: '#' },
      // { name: 'Security', href: '#' }
    ]
  };

  const socialLinks = [
    { name: 'Twitter', icon: Twitter, href: '#' },
    { name: 'Facebook', icon: Facebook, href: '#' },
    { name: 'Instagram', icon: Instagram, href: '#' },
    { name: 'YouTube', icon: Youtube, href: '#' }
  ];

  return (
    <footer className="relative bg-slate-900 border-t border-slate-800">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-10">
        <img 
          src="https://images.unsplash.com/photo-1608154118867-fe3a5ccb11c8" 
          alt="Sports stadium"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-900/80"></div>
      </div>

      <div className="relative z-10">
        {/* Pre-footer CTA */}
        <div className="border-b border-slate-800">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <motion.div 
              className="text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Ready to Transform Your
                <span className="block bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                  Sports Broadcasting?
                </span>
              </h2>
              <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
                Join thousands of broadcasters creating professional sports graphics with Sport Stream Kit.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <motion.button
                  className="bg-gradient-to-r from-blue-600 to-cyan-500 text-white px-8 py-4 rounded-xl font-semibold hover:from-blue-700 hover:to-cyan-600 transition-all duration-200 shadow-lg flex items-center justify-center space-x-2"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => window.open('https://portal.sportstreamkit.com/register', '_blank')}
                >
                  <span>Join</span>
                  <ArrowRight className="h-5 w-5" />
                </motion.button>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Main Footer */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <motion.div 
                className="flex items-center space-x-2 mb-6"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                {/* <div className="bg-gradient-to-r from-blue-500 to-cyan-400 p-2 rounded-lg">
                  <Zap className="h-6 w-6 text-white" />
                </div>
                <span className="text-xl font-bold text-white">Sport Stream Kit</span> */}
                  <img src={Logo} alt="Logo" style={{ width: 'auto', height: '52px' }} />
              </motion.div>
              
              <motion.p 
                className="text-slate-400 mb-6 leading-relaxed"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
              >
                Empowering broadcasters worldwide with professional-grade sports graphics. 
                Transform your live streams with dynamic, animated overlays that engage your audience.
              </motion.p>

              {/* Contact Info */}
              <div className="space-y-3">
                <div className="flex items-center space-x-3 text-slate-400">
                  <Mail className="h-4 w-4" />
                  <span>info@sportstreamkit.com</span>
                </div>
                {/* <div className="flex items-center space-x-3 text-slate-400">
                  <Phone className="h-4 w-4" />
                  <span>+1 (555) 123-4567</span>
                </div>
                <div className="flex items-center space-x-3 text-slate-400">
                  <MapPin className="h-4 w-4" />
                  <span>San Francisco, CA</span>
                </div> */}
              </div>
            </div>

            {/* Footer Links */}
            {Object.entries(footerLinks).map(([category, links], index) => (
              <motion.div 
                key={category}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <h3 className="text-white font-semibold mb-4 capitalize">
                  {category}
                </h3>
                <ul className="space-y-3">
                  {links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a 
                        href={link.href}
                        className="text-slate-400 hover:text-white transition-colors duration-200"
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-slate-800">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              {/* Copyright */}
              <motion.div 
                className="text-slate-400 text-sm"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                © 2025 Sport Stream Kit. All rights reserved.
              </motion.div>

              {/* Social Links */}
              {/* <motion.div 
                className="flex items-center space-x-4"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                {socialLinks.map((social, index) => (
                  <motion.a
                    key={index}
                    href={social.href}
                    className="bg-slate-800 p-2 rounded-lg hover:bg-slate-700 transition-colors duration-200 group"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <social.icon className="h-4 w-4 text-slate-400 group-hover:text-white transition-colors" />
                  </motion.a>
                ))}
              </motion.div> */}

              {/* Trust Badges */}
              <motion.div 
                className="flex items-center space-x-4 text-sm text-slate-400"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <div className="flex items-center space-x-1">
                  <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                  <span>99.9% Uptime</span>
                </div>
                <div className="flex items-center space-x-1">
                  <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                  <span>SOC 2 Compliant</span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;